export default {
  title: '',
  tab: '求职者'
}
